const FETCH_ALERTS_START = 'alerts/FETCH_ALERTS_START';
const FETCH_ALERTS_SUCCESS = 'alerts/FETCH_ALERTS_SUCCESS';
const FETCH_ALERTS_ERROR = 'alerts/FETCH_ALERTS_ERROR';

export default {
  FETCH_ALERTS_START,
  FETCH_ALERTS_SUCCESS,
  FETCH_ALERTS_ERROR,
};
